'use client';

import React from 'react';
import { ImageContainer as StyledImageContainer, ImageBackground } from './elements';
import { TemplateContext } from '../TemplateContext';
export const ImageContainer = ({
  children,
  hideOnMobile
}) => {
  const context = React.useContext(TemplateContext);
  return /*#__PURE__*/React.createElement(StyledImageContainer, {
    hideOnMobile: hideOnMobile,
    assetType: context.assetType
  }, context.assetType === 'flat' ? children : /*#__PURE__*/React.createElement(ImageBackground, null, children));
};